import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { InfoButton } from '@/domain/mitarbeiter/shared/components/InfoButton';
import { Auszahlungsgrenze } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/Auszahlungsgrenze';
import { AuszahlungsgrenzeEinheit } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/AuszahlungsgrenzeEinheit';
import { Richtwert } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/Richtwert';
import { RichtwertEinheit } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/RichtwertEinheit';
import { RichtwertToggle } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/RichtwertToggle';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Body, Heading, RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

// oxlint-disable-next-line max-lines-per-function
export function ArbeitszeitkontoStundenlohn() {
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4">
        <div className="flex gap-1 items-center">
          <Heading>
            {t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.description',
            )}
          </Heading>
          <InfoButton>
            <Body>
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.info',
              )}
            </Body>
          </InfoButton>
        </div>

        <form.AppField
          name="bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze"
          listeners={{
            onChange() {
              ctx.resetDependentFields(
                'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze',
              );
            },
          }}>
          {(field) => (
            <FieldBase>
              <RadioGroup
                value={field.state.value?.toString()}
                onValueChange={(e) => {
                  field.handleChange(e === 'true');
                }}
                className="flex flex-row">
                <RadioGroupItem
                  variant="card"
                  layout="horizontal"
                  label={t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.options.true',
                  )}
                  value={'true'}
                  className="w-full"
                />
                <RadioGroupItem
                  variant="card"
                  layout="horizontal"
                  label={t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.options.false',
                  )}
                  value={'false'}
                  className="w-full"
                />
              </RadioGroup>
            </FieldBase>
          )}
        </form.AppField>
      </div>
      <form.Subscribe
        selector={(state) => ({
          auszahlungsgrenze:
            state.values.bezahlung.arbeitszeitkonto.stundenloehner
              ?.auszahlungsgrenze,
        })}>
        {({ auszahlungsgrenze }) => (
          <>
            {auszahlungsgrenze === true && <AuszahlungsgrenzeEinheit />}
            {auszahlungsgrenze === false && <RichtwertToggle />}
          </>
        )}
      </form.Subscribe>
      <form.Subscribe
        selector={(state) => ({
          richtwert:
            state.values.bezahlung.arbeitszeitkonto.stundenloehner?.richtwert,
        })}>
        {({ richtwert }) => <>{richtwert === true && <RichtwertEinheit />}</>}
      </form.Subscribe>
      <form.Subscribe
        selector={(state) => ({
          auszahlungsgrenzeEinheit:
            state.values.bezahlung.arbeitszeitkonto.stundenloehner
              ?.auszahlungsgrenzeEinheit,
          richtwertEinheit:
            state.values.bezahlung.arbeitszeitkonto.stundenloehner
              .richtwertEinheit,
        })}>
        {({ auszahlungsgrenzeEinheit, richtwertEinheit }) => (
          <>
            {auszahlungsgrenzeEinheit !== null && <Auszahlungsgrenze />}
            {richtwertEinheit !== null && <Richtwert />}
          </>
        )}
      </form.Subscribe>
    </div>
  );
}
